var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9062 17.7812L14.3047 13.1797C15.4453 11.7891 16.1328 10.0078 16.1328 8.06641C16.1328 3.61328 12.5195 0 8.06641 0C3.60938 0 0 3.61328 0 8.06641C0 12.5195 3.60938 16.1328 8.06641 16.1328C10.0078 16.1328 11.7852 15.4492 13.1758 14.3086L17.7773 18.9062C18.0898 19.2188 18.5938 19.2188 18.9062 18.9062C19.2188 18.5977 19.2188 18.0898 18.9062 17.7812ZM8.06641 14.5273C4.5 14.5273 1.60156 11.6289 1.60156 8.06641C1.60156 4.50391 4.5 1.60156 8.06641 1.60156C11.6289 1.60156 14.5312 4.50391 14.5312 8.06641C14.5312 11.6289 11.6289 14.5273 8.06641 14.5273Z",
    fill: "#A9A9A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.fcc657d43c979fe4ce695e5f4a6b564b.svg";
export { ForwardRef as ReactComponent };